'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HeadInfoConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeadInfoConstants = exports.HeadInfoConstants = (0, _keymirror2.default)({
    SHOW_SIDEMENU: null,
    HIDE_SIDEMENU: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/headInfo.js
// module id = 1870
// module chunks = 0